





















import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component
export default class TenantTicketsHeader extends Vue {
    public tabKey: string = 'all';

    constructor() {
        super();
    }

    public tabClickHandler(type: string) {
        this.$store.dispatch(Actions.FETCH_ALL_USER_TICKETS, { vue: this, type });
        this.tabKey = type;
    }

    public isActiveClass(elementTabKey: string) {
        return {
            'hococo-active-tab': (this.tabKey === elementTabKey),
            'hococo-inactive-tab': (this.tabKey !== elementTabKey),
        };
    }
}
